import { type Component, Show } from "solid-js";

interface Props {
  /** True if no successful search has completed yet (first-ever query). */
  firstRun: boolean;
}

export const Loading: Component<Props> = (props) => {
  return (
    <output class="loading" aria-live="polite">
      <div class="loading-spinner" aria-hidden="true" />
      <div class="loading-text">
        <Show when={props.firstRun} fallback={<span>Searching…</span>}>
          <span>Loading search engine…</span>
          <small>First visit only — downloading a 33 MB embedding model and a 4 MB index.</small>
        </Show>
      </div>
    </output>
  );
};
